<template>
  <component
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view></router-view>
    </transition>
  </component>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed, getCurrentInstance, onMounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'

// Layouts
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'

// Dynamic vh
import useDynamicVh from '@core/utils/useDynamicVh'

import { odbRequest, oculisRequest, skutopiaRequest } from '@/config/authConfig';
import { initSkutopiaApi, initODBApi, initOculisApi } from '@axios';

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutBlank,
  },
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    useDynamicVh()

    onMounted(() => {
      const skutopiaApiBaseURL = process.env.VUE_APP_SKUTOPIA_BASE_URL; 
      const odbApiBaseURL = process.env.VUE_APP_ODB_BASE_URL; 
      const oculisApiBaseURL = process.env.VUE_APP_OCULIS_BASE_URL; 
     
      initSkutopiaApi(skutopiaApiBaseURL, skutopiaRequest.scopes);
      initODBApi(odbApiBaseURL, odbRequest.scopes);
      initOculisApi(oculisApiBaseURL, oculisRequest.scopes);
    })

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
}
</script>
